import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Forgot from "./pages/Forgot";
import Reset from "./pages/Reset";
import AdminLogin from "./pages/AdminLogin";
import AdminPanel from "./pages/AdminPanel";
import Player from "./pages/Player";

function Loading() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-rv-darkest">
      <span className="spinner" style={{ width: 26, height: 26 }} />
    </div>
  );
}

function ProtectedUser({ children }) {
  const { user, isAdmin } = useAuth();
  if (user === null && !isAdmin) return <Loading />;
  if (!user && !isAdmin) return <Navigate to="/login" replace />;
  return children;
}

function ProtectedAdmin({ children }) {
  const { isAdmin } = useAuth();
  if (!isAdmin) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<Forgot />} />
            <Route path="/reset-password" element={<Reset />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedAdmin><AdminPanel /></ProtectedAdmin>} />
            <Route path="/" element={<ProtectedUser><Player /></ProtectedUser>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
